import React, { createContext, useContext, useState } from 'react';
import { Language, translations, T } from '../i18n/translations';

const STORAGE_KEY = 'pp_lang';

function getSavedLanguage(): Language {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === 'pt' ? 'pt' : 'en';
}

interface LanguageContextValue {
  language: Language;
  t: T;
  toggleLanguage: () => void;
}

const LanguageContext = createContext<LanguageContextValue>({} as LanguageContextValue);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>(getSavedLanguage());

  const toggleLanguage = () => {
    const next: Language = language === 'en' ? 'pt' : 'en';
    setLanguage(next);
    localStorage.setItem(STORAGE_KEY, next);
  };

  return (
    <LanguageContext.Provider value={{ language, t: translations[language], toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
